import config from '@/utils/ApiUtils'
import { fetchWithToken } from '../utils/Keycloak'

const RenewalService = {
  getAll() {
    return fetchWithToken(config().renewalBackend, { method: 'GET' })
      .then(response => response.json())
  },

  create(renewal) {
    return fetchWithToken(config().renewalBackend, {
      method: 'POST',
      body: JSON.stringify(renewal)
    })
      .then(response => response.json())
  },

  update(renewal) {
    return fetchWithToken(`${config().renewalBackend}/${renewal.id}`, {
      method: 'PUT',
      body: JSON.stringify(renewal)
    })
      .then(response => response.json())
  },

  remove(id) {
    return fetchWithToken(`${config().renewalBackend}/${id}`, {
      method: 'DELETE'
    })
      .then(response => response.json())
  }
}

export default RenewalService
